// extracted by mini-css-extract-plugin
module.exports = {"dividerWrapper":"Divider_dividerWrapper__jmZ3l"};